import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from '@/components/errors/ErrorBoundary';
import TrackPageView from '@/components/layouts/TrackPageView';
import DocumentTitle from '@/components/ui/documentTitle/DocumentTitle';
import ModalRoot from '@/components/ui/modals/ModalRoot';
import Toast from '@/components/ui/toasts/Toast';
import AutoLogin from '@/features/login/components/AutoLogin';
import Providers from '@/providers/Providers';
import Routes from '@/routes/Routes';
import ScrollToTop from '@/utils/ScrollToTop';

const App: React.FC = () => (
  <Providers>
    <BrowserRouter>
      <DocumentTitle />
      <ErrorBoundary>
        <AutoLogin>
          <Routes />
        </AutoLogin>
        <ScrollToTop />
        <ModalRoot />
        <Toast />
        <TrackPageView />
      </ErrorBoundary>
    </BrowserRouter>
  </Providers>
);

export default App;
